"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.smartDate = exports.SmartDate = void 0;
const jalali_moment_1 = __importDefault(require("jalali-moment"));
const lang_utils_1 = require("../lang.utils");
class SmartDate {
    constructor(date) {
        this.persianDigits = false;
        if (date) {
            if (typeof date === 'string' || typeof date === 'number' || jalali_moment_1.default.isMoment(date) || date instanceof Date) {
                this.mDate = (0, jalali_moment_1.default)(date);
            }
            else if (date instanceof SmartDate) {
                this.mDate = (0, jalali_moment_1.default)(date.mDate.clone());
            }
            else {
                throw new Error('Invalid date format');
            }
        }
        else {
            this.mDate = (0, jalali_moment_1.default)();
        }
    }
    utcOffset(offset) {
        this.mDate = this.mDate.utcOffset(offset);
        return this;
    }
    persian() {
        this.persianDigits = true;
        return this;
    }
    humanReadable() {
        const date = this.mDate.format('YYYY/MM/DD HH:mm');
        return this.persianDigits ? (0, lang_utils_1.numbersToPersian)(date) : date;
    }
    toISOString() {
        return this.mDate.toISOString();
    }
    toBeginningOfDay() {
        this.mDate.startOf('day');
        return this;
    }
    toDate() {
        return this.mDate.toDate();
    }
    getMoment() {
        return this.mDate;
    }
    diffMinutes(date) {
        return this.mDate.diff(date.getMoment(), 'minutes');
    }
    diffHours(date) {
        return this.mDate.diff(date.getMoment(), 'hours');
    }
    diffSeconds(date) {
        return this.mDate.diff(date.getMoment(), 'seconds');
    }
    add(duration, type) {
        this.mDate.add(duration, type);
        return this;
    }
    subtract(duration, type) {
        this.mDate.subtract(duration, type);
        return this;
    }
    startOf(time) {
        this.mDate.startOf(time);
        return this;
    }
    endOf(time) {
        this.mDate.endOf(time);
        return this;
    }
    duration(input) {
        return jalali_moment_1.default.duration((0, jalali_moment_1.default)(input instanceof SmartDate ? input.mDate : input).diff(this.mDate));
    }
    format(format) {
        const date = this.mDate.format(format);
        if (this.persianDigits) {
            return (0, lang_utils_1.numbersToPersian)(date);
        }
        return date;
    }
    formatJalali(format = 'jYYYY/jMM/jDD HH:mm') {
        return this.format(format);
    }
    availabilityBlockRanges(startTime, endTime) {
        const [startH, startM] = startTime.split(':').map(Number);
        const [endH, endM] = endTime.split(':').map(Number);
        const start = new SmartDate(this.mDate.clone());
        start.getMoment().hours(startH).minutes(startM).seconds(0).milliseconds(0);
        const end = new SmartDate(this.mDate.clone());
        end.getMoment().hours(endH).minutes(endM).seconds(0).milliseconds(0);
        return { start, end };
    }
    blockTimeInJalali(block) {
        const { start, end } = this.availabilityBlockRanges(block.startTime, block.endTime);
        const startTime = start.getMoment().format('HH:mm');
        const endTime = end.getMoment().format('HH:mm');
        return {
            startTime: (0, lang_utils_1.numbersToPersian)(startTime),
            endTime: (0, lang_utils_1.numbersToPersian)(endTime),
        };
    }
}
exports.SmartDate = SmartDate;
const smartDate = (date) => {
    return new SmartDate(date);
};
exports.smartDate = smartDate;
